<template>
  <div class="rb-container">
    <el-row class="tcf-row">
      <div class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="日期">
              <el-date-picker
                v-model="searchForm.dateSearch"
                size="small"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" @click="editRow(null)" type="primary">添加月报</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="tableLoading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    prop="user_name"
                    label="姓名"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="time"
                    width="170"
                    label="提交时间">
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="工作内容"
                    min-width="200"
                    :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作"
                    width="180">
                    <template slot-scope="scope">
                      <el-button @click="editRow(scope.row)" size="mini" icon="el-icon-edit-outline">编辑</el-button>
                      <el-button @click="deleteRow(scope.row)" size="mini" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </el-row>
    <el-dialog
      :title="editData.dailyId!==0?'编辑月报':'添加月报'"
      :visible.sync="dialogVisible"
      width="65%"
      :key="editData.dailyId"
      :before-close="handleClose">
        <el-form ref="editData" :rules="formRules" size="small" :model="editData" label-width="100px">
          <el-form-item label="本月工作内容" prop="content">
            <el-input v-model="editData.content" type="textarea" :rows="5" resize="none"/>
          </el-form-item>
          <el-form-item label="上传图片" prop="images">
            <MultiImg :key="editData.key" :limit="9" :size="'sm'" v-model="editData.images" :old="editData.oldImages"/>
          </el-form-item>
          <el-form-item label="上传附件" prop="files">
            <MultiFile :key="editData.key" v-model="editData.files" :old="editData.oldFiles"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="btnLoading" type="primary" @click="subDaily('editData')">立即提交</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getUser } from '@/utils/auth'
  import { getDailyList} from '@/api/work'
  import { getDailyDetail} from '@/api/work'
  import { addOrEditDaily} from '@/api/work'
  import { deleteDaily} from '@/api/work'
  import MultiImg from '@/components/upload/MultiImg'
  import MultiFile from '@/components/upload/MultiFile'
  import { getUserWork} from '@/api/work'

  export default {
    components: { MultiFile, MultiImg },
    computed: {
      user: getUser
    },
    created() {
      this.getUserDailyList()
      this.getUserWork()
    },
    data(){
      return{
        searchForm: {
          search: '',
          dateSearch: []
        },
        tableData: [],
        tableLoading: false,
        btnLoading: false,
        beginTime: '',
        endTime: '',
        workData: [],
        currentPage: 1,
        pageSize: 20,
        total: 0,
        work: '',
        editData: {
          dailyId: 0,
          plan: '',
          content: '',
          files: [],
          images: [],
          oldFiles: [],
          oldImages: [],
          key: ''
        },
        dialogVisible: false,
        formRules: {
          content :[
            {required: true, message: '请输入工作计划', trigger: 'blur' },
          ]
        }
      }
    },
    methods:{
      handleSizeChange(val) {
        this.pageSize = val
        this.currentPage = 1
        this.getUserDailyList()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getUserDailyList()
      },
      editRow(row){
        if(row!=null){
          this.editData.dailyId = row.daily_id
          const data = {
            userid: this.user.dUserid,
            dailyid: row.daily_id
          }
          this.editData.oldFiles = []
          this.editData.oldImages = []
          getDailyDetail(data).then(response=>{
            this.editData.content = response.data.content
            this.editData.plan = response.data.plan
            for(let i = 0;i<response.data.filesList.length;i++){
              const data = {
                id: response.data.filesList[i].file_id,
                url: response.data.filesList[i].file_path,
                name: response.data.filesList[i].file_name
              }
              this.editData.oldFiles.push(data)
            }
            for(let i = 0;i<response.data.imgList.length;i++){
              const data = {
                id: response.data.imgList[i].img_id,
                url: response.data.imgList[i].img_url,
              }
              this.editData.oldImages.push(data)
            }
            this.editData.key = new Date().getTime().toString()
            this.dialogVisible = true
          })
        }else{
          this.editData.dailyId = 0
          if(this.work.length>0){
            for(let i = 0;i<this.work.length;i++){
              this.editData.content = this.editData.content + this.work[i] +'\n'
            }
          }
          this.editData.key = new Date().getTime().toString()
          this.dialogVisible = true
        }
      },
      subDaily(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            const data = {
              dailyid: this.editData.dailyId,
              userid: this.user.dUserid,
              plan: this.editData.plan,
              content: this.editData.content,
              imgStr: this.editData.images.toString(),
              fileStr: this.editData.files.toString(),
              type: 2
            }
            addOrEditDaily(data).then(response=>{
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.btnLoading = false
              this.dialogVisible = false
              this.getUserDailyList()
            }).catch(() => {
              this.btnLoading = false
            });
          }
        });
      },
      /*resetForm(formName){
        this.$refs[formName].resetFields();
      },*/
      deleteRow(row){
        if(row!=null){
          this.$confirm('您确定要删除这条记录吗?', '提示', {
            confirmButtonText: '是的',
            cancelButtonText: '再想想',
            type: 'warning'
          }).then(() => {
            const data = {
              dailyId: row.daily_id
            }
            deleteDaily(data).then(response=>{
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getUserDailyList()
            })
          }).catch(() => {
          });
        }
      },
      Search(){
        if(this.searchForm.dateSearch!==null && this.searchForm.dateSearch.length>0){
          this.beginTime = this.searchForm.dateSearch[0]
          this.endTime = this.searchForm.dateSearch[1]
        }else {
          this.beginTime = ''
          this.endTime = ''
        }
        this.currentPage = 1
        this.getUserDailyList()
      },
      getUserDailyList(){
        this.tableLoading = true
        const data = {
          page: this.currentPage,
          limit: this.pageSize,
          type: 2,
          userid: this.user.dUserid,
          beginTime: this.beginTime,
          endTime: this.endTime,
          content: this.searchForm.search
        }
        getDailyList(data).then(response=>{
          this.tableData = response.data
          this.total = response.total
          this.tableLoading = false
        })
      },
      handleClose(done){
        this.editData.dailyId = 0
        this.editData.plan = ''
        this.editData.content = ''
        this.editData.files = []
        this.editData.images = []
        this.editData.oldFiles = []
        this.editData.oldImages = []
        done()
      },
      getUserWork(){
        const data = {
          userid: this.user.dUserid,
          type: 2
        }
        getUserWork(data).then(response=>{
          this.work = response.data
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rb-container {
    margin: 30px;
  }
  .tcf-row{
    padding: 0;
    .card{
      .card-body{
        .card-title{
          font-weight: 500;
          color: #404852;
          margin-bottom: 22px;
          font-size: 14px;
        }
        .search-area{
          float: right;
        }
        .card-content{
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }

</style>
